import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/admin/customer/product_order/invoice_list";

export default {
  getListOfAllInvoices(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfSampleInvoices(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/customer/sample-order/invoice-list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  redirectToInvoice(code) {
    return Repository.get(`/admin/others/short-link/${code}`)
  }
};
